import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type SidebarSection } from '@/types/config'

interface ConfigState {
	activeSection: SidebarSection | null
	menuSection: SidebarSection
}

const initialState: ConfigState = {
	activeSection: null,
	menuSection: 'sport',
}

const configSlice = createSlice({
	name: 'config',
	initialState,
	reducers: {
		setActiveSection(state, action: PayloadAction<SidebarSection>) {
			state.activeSection = action.payload
			state.menuSection = action.payload
		},
		clearActiveSection(state) {
			state.activeSection = null
		},
	},
})

export const { setActiveSection, clearActiveSection } = configSlice.actions

export const selectActiveSection = (state: { config: ConfigState }) => state.config.activeSection

export const selectMenuSection = (state: { config: ConfigState }) => state.config.menuSection

export default configSlice.reducer
